export const ANSWERS_LOADED = "ANSWERS_LOADED";
export const ANSWER_CHANGE = "ANSWER_CHANGE";
export const UPDATED_SUMMARY_TABLE = "UPDATED_SUMMARY_TABLE";
export const UPDATED_CALCULATED_VALUE_ANSWERS =
  "UPDATED_CALCULATED_VALUE_ANSWERS";
export const NEW_SERVER_ANSWERS = "NEW_SERVER_ANSWERS";
export const PATCH_SERVER_ANSWER = "PATCH_SERVER_ANSWER";
